window.emailFormatter = function(value, row) {
    if (value) {
        return '<a href="mailto:'+value+'">'+value+'</i>';
    }
};
